import React from 'react';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/styles';
// eslint-disable-next-line import/no-named-as-default -- posthog-js re-exports its own default as a named `posthog` too
import posthog from 'posthog-js';
import { useHistory } from 'react-router-dom';
import useUserInfo from '../../auth/useUserInfo';
import { useDispatch } from '../../lib/reduxHooks';
import { createNewEnvelope } from '../../store/envelopeManagement/actions';
import { StyledMenu, StyledMenuItem } from '../common/StyledMenu';

interface IProps {
  disabled?: boolean;
  isPrimeAuthenticated?: boolean;
  isPrimeUser?: boolean;
}

const useStyles = makeStyles(() => ({
  icon: {
    margin: '-4px 0 -4px 4px',
  },
}));

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const NewEnvelopeButton = (props: IProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();
  const { impersonatedPrimeUserGuid } = useUserInfo() ?? {};

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const chooseProperty = () => {
    setAnchorEl(null);
    history.push('/dtm/properties');
  };

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const noProperty = () => {
    setAnchorEl(null);
    posthog.capture('envelope_creation_started');
    dispatch(createNewEnvelope(impersonatedPrimeUserGuid));
  };

  return (
    <>
      {props.isPrimeUser ? (
        <>
          <Button variant="contained" color="primary" onClick={handleClick} disabled={props.disabled}>
            New Envelope <ExpandMoreIcon className={classes.icon} />
          </Button>
          <StyledMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            getContentAnchorEl={null}
          >
            <StyledMenuItem onClick={chooseProperty} disabled={!props.isPrimeAuthenticated}>
              Choose property
            </StyledMenuItem>
            <StyledMenuItem onClick={noProperty}>No property</StyledMenuItem>
          </StyledMenu>
        </>
      ) : (
        <Button variant="contained" color="primary" onClick={noProperty} disabled={props.disabled}>
          New Envelope
        </Button>
      )}
    </>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default NewEnvelopeButton;
